import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import $ from "jquery";
import LoaderAHSF from "../../../../Components/LoaderAHSF";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import {
  GetAllTG_JordanianGovernoratesName,
  GetListJordanianGovernorates,
} from "../../../../Redux/Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/DropDowntJordanianGovernorates";
import AddJordanianGovernoratesProjectActivities from "../../../../Services/ProjectInformationPage/InformationAboutTheTargetGroup/JordanianGovernoratesProjectActivities/AddJordanianGovernoratesProjectActivities";
import UpdateJordanianGovernoratesProjectActivities from "../../../../Services/ProjectInformationPage/InformationAboutTheTargetGroup/JordanianGovernoratesProjectActivities/UpdateJordanianGovernoratesProjectActivities";
import {
  GetOneJordanianGovernoratesProjectActivitiesData,
  restValidationJorList,
  ValidateOneJordanianGovernoratesProjectActivitiesData,
} from "../../../../Redux/Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/GetOneJordanaian/indexOne";
import Swal from "sweetalert2";

const AddEditJordanianGovermentProject = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      DropDownJordanianGovernoratesName:
        state.DropDownJordanianGovernoratesName
          .DropDownJordanianGovernoratesName,

      JordanianGovernoratesList:
        state.DropDownJordanianGovernoratesName.JordanianGovernoratesList,

      TargetInfo: state.TargetInfo.TargetInfo,
      OneJordanianGovernoratesProjectActivitiesData:
        state.OneJordanianGovernoratesProjectActivitiesData
          .OneJordanianGovernoratesProjectActivitiesData,
      loadingOneJordanianGovernoratesProjectActivitiesData:
        state.OneJordanianGovernoratesProjectActivitiesData
          .loadingOneJordanianGovernoratesProjectActivitiesData,
      tG_MainTargetedGroupId:
        state.TargetInfo.TargetInfo.tG_MainTargetedGroupId,
      OneValidateOneJordanianGovernoratesProjectActivitiesData:
        state.OneJordanianGovernoratesProjectActivitiesData
          .OneValidateOneJordanianGovernoratesProjectActivitiesData,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  }); // Map Redux state to local variables
  console.log(state.tG_MainTargetedGroupId, "tG_MainTargetedGroupId");
  // Define the initial state for the Jordanian governorates list
  const [JordanianList, setJordanianList] = useState({
    tG_JordanianGovernoratesProjectActivitiesId:
      state.OneJordanianGovernoratesProjectActivitiesData
        ?.tG_JordanianGovernoratesProjectActivitiesId,
    tG_JordanianGovernoratesNameId:
      state.OneJordanianGovernoratesProjectActivitiesData
        ?.tG_JordanianGovernoratesNameId,
    tG_MainTargetedGroupId: state.tG_MainTargetedGroupId,
  });

  //console.log(state.OneInformationAboutTheTargetGroupOfTheProject, "dd");
  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  // Fetch all governorate names when the component is mounted
  useEffect(() => {
    dispatch(GetAllTG_JordanianGovernoratesName());
  }, []);

  useEffect(() => {
    dispatch(GetListJordanianGovernorates(state.tG_MainTargetedGroupId));
  }, []);

  // const AddJordanian = async () => {
  //   await AddJordanianGovernoratesProjectActivities(
  //     JordanianList.tG_JordanianGovernoratesNameId,
  //     state.tG_MainTargetedGroupId
  //   );
  //   $(".close-btn").trigger("click");
  //   dispatch(setRefreshTable());
  // };
  // Function to add a new Jordanian governorate to the project
  const AddJordanian = async () => {
    const validationList = await dispatch(
      ValidateOneJordanianGovernoratesProjectActivitiesData({
        tG_JordanianGovernoratesNameId:
          JordanianList.tG_JordanianGovernoratesNameId,
      })
    );
    const isDuplicate = state.JordanianGovernoratesList.some(
      (sector) =>
        sector.tG_JordanianGovernoratesNameId ==
        JordanianList.tG_JordanianGovernoratesNameId
    );

    if (isDuplicate) {
      // Show an error alert if the governorate is already selected
      Swal.fire({
        position: "center",
        icon: "error",
        title: "لا يمكنك اختيار هذه المحافظة مرة اخرى",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }
    //console.log(JordanianList.tG_JordanianGovernoratesNameId, "tg");
    // Proceed if the validation list is empty
    if (validationList.payload.length === 0) {
      await AddJordanianGovernoratesProjectActivities(
        JordanianList.tG_JordanianGovernoratesNameId,
        state.tG_MainTargetedGroupId
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };

  useEffect(() => {
    dispatch(restValidationJorList());
  }, []);
  // Function to update an existing Jordanian governorate
  const UpdateJordanian = async () => {
    const isDuplicate = state.JordanianGovernoratesList.some(
      (sector) =>
        sector.tG_JordanianGovernoratesNameId ==
        JordanianList.tG_JordanianGovernoratesNameId
    );

    if (isDuplicate) {
      // Show an error alert if the governorate is already selected
      Swal.fire({
        position: "center",
        icon: "error",
        title: "لا يمكنك اختيار هذه المحافظة مرة اخرى",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }
    await UpdateJordanianGovernoratesProjectActivities(
      JordanianList.tG_JordanianGovernoratesProjectActivitiesId,

      JordanianList.tG_JordanianGovernoratesNameId,

      JordanianList.tG_MainTargetedGroupId
    );
    $(".close-btn").trigger("click");
    Swal.fire({
      position: "center",
      icon: "success",
      title: "تم تعديل المعلومات بنجاح",
      showConfirmButton: false,
      timer: 1500,
      // width: "500px",
    });
    dispatch(setRefreshTable());
  };
  // Fetch a specific governorate's data when the component is loaded
  useEffect(() => {
    if (props != null) {
      dispatch(
        GetOneJordanianGovernoratesProjectActivitiesData(
          props.tG_JordanianGovernoratesProjectActivitiesId
        )
      );
    }
  }, [props.tG_JordanianGovernoratesProjectActivitiesId]);
  useEffect(() => {
    if (
      !state.loadingOneJordanianGovernoratesProjectActivitiesData &&
      Object.keys(props).length != 0
    ) {
      setJordanianList({
        ...state.OneJordanianGovernoratesProjectActivitiesData,
      });
    } else {
      setJordanianList({
        tG_JordanianGovernoratesNameId: null,
        tG_MainTargetedGroupId: state.tG_MainTargetedGroupId,
      });
    }
  }, [state.OneJordanianGovernoratesProjectActivitiesData]);

  return (
    <>
      {!state.loadingOneJordanianGovernoratesProjectActivitiesData ? (
        <>
          <div className="AddEdite">
            <AllDropDownsAHSF
              fieldsName="city"
              show={true}
              disabled={shouldDisableFields}
              arrayOoptionList={state.DropDownJordanianGovernoratesName}
              KeyText={"tG_JordanianGovernoratesNameAr"}
              KeyValue={"tG_JordanianGovernoratesNameId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setJordanianList({
                  ...JordanianList,
                  tG_JordanianGovernoratesNameId: Number(e.target.value),
                });
              }}
              defaultValue={JordanianList.tG_JordanianGovernoratesNameId}
              showValidationMessage={
                state.OneValidateOneJordanianGovernoratesProjectActivitiesData
                  ? state.OneValidateOneJordanianGovernoratesProjectActivitiesData.includes(
                      "city"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            {!shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit"
                        ? UpdateJordanian()
                        : AddJordanian();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF
        show={state.loadingOneJordanianGovernoratesProjectActivitiesData}
      />
    </>
  );
};

export default AddEditJordanianGovermentProject;
